import React from "react";
import { Button } from "antd";

export default function BigButton({ children, style, ...rest }) {
  const styleMerge = {
    boxShadow: "none",
    fontSize: 16,
    height: 54,
    borderRadius: 5,
    fontWeight: 600,
    color: "#181A20",
    ...style,
  };

  return (
    <Button type="primary" style={styleMerge} {...rest}>
      {children}
    </Button>
  );
}
